import { z } from "zod";

export const createDisableReservationsSchema = (t: any) =>
  z.object({
    reason: z
      .string()
      .min(1, t("workspaces:settings.reservations.disableDialog.reasonRequired"))
      .max(500, t("workspaces:settings.reservations.disableDialog.reasonMaxLength")),
  });

export type DisableReservationsFormData = z.infer<
  ReturnType<typeof createDisableReservationsSchema>
>;

export const createBlockWorkspaceSchema = (t: any) =>
  z.object({
    reason: z
      .string()
      .max(500, t("workspaces:settings.blockWorkspace.dialog.reasonMaxLength"))
      .optional(),
  });

export type BlockWorkspaceFormData = z.infer<ReturnType<typeof createBlockWorkspaceSchema>>;
